angular.module('contactModule').component('agentSection', {
	templateUrl: 'agentSection/agentSection.html',
	bindings: {
		agents: '<',
		user: '<',
		pageLabel: '@',
		trackCategory: '@',
		trackAction: '@',
		trackLabel: '@',
		isMobile: '@',
		type: '@',
		listingId: '@',
		token: '@',
		courtesy: '@'
	}, 
	controller: ['$timeout', '$element', function($timeout, $element) {
		var ctrl = this;
		console.log(this.agents);
		this.$onInit = () => {
			this.isM = this.isMobile === '1';
			this.displayShowMore = true;
			this.isBroker = B;
			console.log(this.isBroker);

			if (this.user.fromLK) {
				this.agents = this.agents.slice(1);
			}

			let agentIndex = 0;
			this.displayedAgents = this.agents.map((agent) => {
				agent.id = agentIndex;
				if (this.isM) {
					if (agentIndex === 0) {
						agent.visible = true;
					} else {
						if (this.user.assigned || this.user.isBroker) {
							agent.visible = true;	
						} else {
							agent.visible = false;
						}
					}
				} else {
					agent.visible = true;
				}
			
				agentIndex++;
				return agent;
			});

		}; 

		this.$postLink = () => {
			$timeout(() => {
				
				// set the height dynamically (for animation effect)
				$element[0].style = `height: ${$element[0].getBoundingClientRect().height}px`;

				let $regLinks = $element[0].querySelectorAll('.reg_blimp');
				for (let i = 0; i < $regLinks.length; i++) {
					// Fire GLOBAL event (jquery and mootools)
					var event = document.createEvent("HTMLEvents");
					event.initEvent("addRegLink", true, true);
					event.eventEl = $regLinks[i];
					document.dispatchEvent(event);		
				}
			});	
		};

		this.toggleMoreAgents = (toggle) => {
			// set height back to auto
			$timeout(() => {
				$element[0].style.height = 'auto';
			});

			let agents = this.displayedAgents.slice(1, this.displayedAgents.length);
			agents.forEach((agent) => {
				agent.visible = toggle;
			});

			this.displayShowMore = !toggle;

			// set height back to auto
			$timeout(() => {
				$element[0].style.height = $element[0].getBoundingClientRect().height + 'px';
			});
		};

		this.showMoreAgents = () => {
			let agents = this.displayedAgents.slice(1, this.displayedAgents.length);
			agents.forEach((agent) => {
				agent.visible = true;
			});
		};

		this.hideMoreAgents = () => {
			let agents = this.displayedAgents.slice(1, this.displayedAgents.length);
			agents.forEach((agent) => {
				agent.visible = false;
			});
		};

	}]
});